import React, {Component} from 'react';
import FormView from './FormView'
import FormViewContainer from '../../../components/Letflow/ViewContainer/FormViewContainer';
import {request} from "api-client";

class FormContainer extends Component {

  state = {
    nameEs: '',
    nameEn: '',
    namePt: '',
    type: '',
    order: '',
    disabled: false,
    types: [],
    selectedTypes: [],
    groupType: 'content',
    isGlobal: "notGlobal",
    targetType: 'talent',
    brandType: 'bloomclouds',
  }

  componentDidMount = () => {
    if (this.props.location.pathname.includes('create')) {
      this.requestContentCreatorTypes()
    }
  }

  setTagGroup = tagGroup => {
    let translationEs = tagGroup.translations.find(translation => translation.locale === 'es')
    let translationEn = tagGroup.translations.find(translation => translation.locale === 'en')
    let translationPt = tagGroup.translations.find(translation => translation.locale === 'pt')

    this.requestContentCreatorTypes().then(() => {
        return this.setState({
          nameEs: translationEs && translationEs.name,
          nameEn: translationEn && translationEn.name,
          namePt: translationPt && translationPt.name,
          type: tagGroup.type,
          order: tagGroup.order,
          selectedTypes: tagGroup.types.filter(tgTypes => this.state.types.find(creationType => tgTypes.type === creationType.value)).map(type => ({value: type.type, label: this.state.types.find(creationType => type.type === creationType.value).label})),
          groupType: tagGroup.creation_group ? 'material' : 'content',
          isGlobal: tagGroup.target_brand ? tagGroup.target_brand : tagGroup.is_global ? "isGlobal" : "notGlobal"
        })
    })
  }

  requestContentCreatorTypes = () =>
    request.contentCreatorType.getAll({filterBy: [
      {column: "type", filter: this.props.isTalent ? 'talent' : this.props.isAudiovisual ? 'audiovisual' : 'editorial'}]})
      .then(contentCreatorTypes => {
        let types = contentCreatorTypes.map(contentCreatorType => ({value: contentCreatorType.slug, label: contentCreatorType.name}))
        this.setState({types})
      })


  onChange = e => this.setState({[e.target.id]: e.target.value })
  submitRequest = () => this.props.submitRequest(this.state)

  render = () => {

    const { nameEs, nameEn, namePt, types, type, disabled, order, groupType, isGlobal, brandType } = this.state

    const { disableTypes, isTalent, isEditorial, creating} = this.props

    return (
      <FormViewContainer
        title={this.props.title}
        submitRequest={this.submitRequest}
        onBack={() => this.props.history.goBack()}
        initializationRequest={this.props.initializationRequest}
        onRequestingStateChanged={value => this.setState({ disabled: value })}
        hasTranslatableInputs
      >
        <FormView
          ref={instance => this.child = instance}
          disabled={disabled}
          nameEs={nameEs}
          nameEn={nameEn}
          namePt={namePt}
          type={type}
          order={order}
          types={types}
          brandType={brandType}
          selectedTypes={this.state.selectedTypes}
          onTypeChange={selectedTypes => this.setState({selectedTypes})}
          onChange={this.onChange}
          disableTypes={disableTypes}
          groupType={groupType}
          isGlobal={isGlobal}
          creating={creating}
          isTalent={this.props.location.pathname.includes('talents')}
          isEditorial={!this.props.location.pathname.includes('talents') && !this.props.location.pathname.includes('audiovisual')}
        />
      </FormViewContainer>
    )
  }
}

export default FormContainer
